export default {
    type: 'dom',
    init: function (GG) {
        if (typeof GG.$ !== 'undefined') {
            GG.attachForm = this.plugin.bind(GG);
            GG.log('AttachForm plugin loaded.');
        }
        else {
            GG.log('AttachForm plugin needs jQuery.');
        }
    },
    plugin: function (formWrapper, handle, options) {
        var $ = this.$;
        var app = this;
        if (typeof formWrapper === 'undefined' || !$(formWrapper).length)
            return false;
        var $parent = $(formWrapper), $form = $parent.find('form'), $loading = $parent.find('.form__loading, .loading'), $wrapper = $parent.find('.form__wrapper'), $error = $parent.find('.form__error');
        var defaults = {
            type: $form.attr('method'),
            url: $form.attr('action'),
            data: $form.serialize(),
            beforeSend: function () {
                $loading.fadeIn();
            },
            beforeSubmit: function () { },
            onDone: function ($wrapper, $error, data) {
                $error.hide();
                var old_height = $wrapper.height(), new_height = 0;
                $wrapper.html(data.message_success);
                new_height = $wrapper.height();
                $wrapper.height(old_height).animate({
                    height: new_height
                });
            }
        };
        var settings = $.extend(defaults, options);
        if (!$(formWrapper).data('formAttached')) {
            var mainAction_1 = function () {
                settings.beforeSubmit();
                settings.data = $form.serialize();
                $.ajax(settings)
                    .done(function (data) {
                    if (data.errors && Object.keys(data.errors).length) {
                        var errors_1 = data.errors;
                        var $list_1 = $('<ul/>').appendTo($error.html(''));
                        $parent
                            .find('*')
                            .removeClass('field__input_error')
                            .removeClass('error');
                        Object.keys(errors_1).forEach(function (key) {
                            $parent
                                .find("[name=\"" + key + "\"]")
                                .closest('label')
                                .addClass('error')
                                .addClass('form__label_error')
                                .end()
                                .addClass('field__input_error')
                                .addClass('error');
                            if (errors_1[key]) {
                                $('<li/>')
                                    .html(errors_1[key])
                                    .appendTo($list_1);
                            }
                        });
                        $error.show();
                    }
                    else {
                        settings.onDone($wrapper, $error, data);
                    }
                })
                    .always(function () {
                    $loading.fadeOut();
                })
                    .fail(function (jqXHR, textStatus, errorThrown) {
                    $error.html(jqXHR.statusText).show();
                });
            };
            if (settings.formsController) {
                if (jQuery.fn.formsController) {
                    var options_1 = $.extend({
                        validationSuccess: function () {
                            mainAction_1();
                        }
                    }, settings.formsController);
                    $form.formsController(options_1);
                }
            }
            else {
                $('body').on('click', handle, function () {
                    if (!$(this).is('[type=submit]')) {
                        mainAction_1();
                        return false;
                    }
                });
            }
            $form.on('submit', function (e) {
                mainAction_1();
                e.preventDefault();
                return false;
            });
            if (app.config.log)
                console.log("GG.AttachFrom attached:", formWrapper);
        }
        else {
            if (app.config.log)
                console.log("GG.AttachFrom already attached:", formWrapper);
        }
        $(formWrapper).data('formAttached', true);
    }
};
